/* eslint-disable */
// @ts-nocheck
import debugLib from 'debug';
import { reducerWrapper } from '../support/utils';
import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';
import type { TiktokReducer } from '../types/adPartnerTypes';
const debug = debugLib('TiktokReducer');
export const INIT_STATE = {
  adAccountStatus: {},
};

function Handler(state: TiktokReducer = INIT_STATE, action) {
  debug('Receive action type ', action.type);

  switch (action.type) {
    case GET_AD_ACCOUNT_STATUS.response:
      return { ...state, adAccountStatus: action.data && action.data.a_tiktok_ads };

    default:
      return state;
  }
}

const Tiktok = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_AD_ACCOUNT_STATUS],
  error: [GET_AD_ACCOUNT_STATUS],
  resetOn: ['APP_CHANGE'],
});
export default Tiktok;
